import React, { Component } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import { dateFormat } from "utils";
import { Avatar, Badge, Divider, List, Pagination } from "antd";
import { UserIcon } from "components";

import { notificationService } from "services";

// Composant qui render un Carousel.
class NotificationsTv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifs: [],
    };

    this.number_notifs = 9;

    this.actionText = {
      Message: {
        create: "a envoyé un message",
      },
      Note: {
        create: "a créé une Intervention",
        update: "a modifié une Intervention",
        delete: "a supprimé une Intervention",
      },
      Incident: {
        create: "a créé un Incident",
        update: "a modifié un Incident",
        delete: "a supprimé un Incident",
      },
      Compliance: {
        create: "a créé une Non-conformité",
        update: "a modifié une Non-conformité",
        delete: "a supprimé une Non-conformité",
      },
    };

    this.actionLink = {
      Message: (id) => ({ pathname: "/chat", search: `${id}`, state: { fromNotif: id } }),
      Note: (id) => "/sse/" + id,
      Incident: (id) => "/incidents/" + id,
      Compliance: (id) => "/notes/" + id,
    };

    this.fetchNotifs = this.fetchNotifs.bind(this);
  }

  componentDidMount() {
    this.fetchNotifs();
  }

  fetchNotifs() {
    notificationService
      .notifs_tv()
      .then((result) => {
        this.setState({ notifs: result.data });
      })
      .catch((e) => {
        this.setState(() => {
          throw new Error(e);
        });
      });
  }

  render() {
    const { notifs } = this.state;

    const avatar = (item) => {
      if (item.user_id == 99) return <Avatar icon="user" />;
      else return <Avatar src={item.user_avatar_url} />;
    };

    const Item = ({ item }) => {
      return (
        <List.Item>
          <List.Item.Meta
            avatar={avatar(item)}
            title={
              <span className="notification-item-title">
                <Link to={this.actionLink[item.type](item.action_id)}>
                  <b>{item.user_name}</b>
                  <span>{` ${(this.actionText[item.type] && this.actionText[item.type][item.action_type]) || item.action_type}`}</span>
                </Link>
                <span className="date">{moment(item.date).format(`${dateFormat} HH:mm`)}</span>
              </span>
            }
            description={item.text}
          />
        </List.Item>
      );
    };

    return (
      <div className="notifications-list-container tv">
        <List
          itemLayout="horizontal"
          dataSource={notifs}
          locale={{ emptyText: "Pas de notifications" }}
          renderItem={(item) => <Item item={item} />}
        />
      </div>
    );
  }
}

export default NotificationsTv;
